import React from 'react';
import { RemindersPage } from '~/components/Reminders';

export function Reminders() {
    return (
        <div className="container">
            <RemindersPage />
        </div>
    );
}
